import React from "react";
import { useParams, Link } from "react-router-dom";
import newsData from "../data/newsData";

const LatestNewsDetails = () => {
  const { id } = useParams();
  const article = newsData.find((item) => item.id === id);

  if (!article) return <p className="text-white">Article not found.</p>;

  return (
    <section className="bg-brandBlue relative text-white font-outfit px-6 py-16 min-h-screen">
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-softGreen/30 blur-3xl rounded-full z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-brandGreen/20 blur-3xl rounded-full z-0" />
      <div className="max-w-4xl mx-auto relative z-[12]">
        <Link
          to="/latestnews"
          className="inline-block mb-6 bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition"
        >
          ← Back to News
        </Link>

        <h1 className="text-3xl font-bold mb-2">{article.title}</h1>
        <p className="text-sm text-softGreen mb-6">{article.date}</p>
        <p className="text-lg text-white leading-relaxed">{article.summary}</p>
        {/* Replace summary with full content if needed */}
      </div>
    </section>
  );
};

export default LatestNewsDetails;
